var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hotelId && _vm.compsetId)?_c('RatesDayPopup',{attrs:{"compsetId":_vm.compsetId,"hotelId":_vm.hotelId}}):_c('RatesPopup'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }